// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Likes":"Likes","counter":"counter","group":"group","top":"top","animate":"animate","danglingDigit":"danglingDigit","order0":"order0","order1":"order1","order2":"order2","order3":"order3","order4":"order4","order5":"order5","bottom":"bottom","icon":"icon","scale":"scale"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/GuestBook/css/Likes.styl
// module id = 1622
// module chunks = 0